import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import { EkkoLogo } from '../EkkoLogo';
import useNavigation from '../../Providers/NavigationProvider';

interface NavHeaderProps {
  isSortingEnabled: boolean;
  onToggleSorting: () => void;
}

export const NavHeader = ({ isSortingEnabled, onToggleSorting }: NavHeaderProps): React.JSX.Element => {
  const { isOpen, setOpen } = useNavigation();

  const toggleButton = (
    <IconButton onClick={() => setOpen(!isOpen)} size="large">
      {isOpen ? <ChevronLeftIcon /> : <MenuIcon />}
    </IconButton>
  );

  return (
    <Box sx={{ p: 1 }}>
      {isOpen ? (
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
          <EkkoLogo width={56} height={20} />
          <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-end'}>
            <Tooltip
              title={'Sort Menu Items'}
              aria-label={'Sort Menu Items'}
              placement={'bottom'}
              enterDelay={150}
              leaveDelay={100}
            >
              <IconButton
                onClick={onToggleSorting}
                size={'large'}
                sx={{
                  ...(isSortingEnabled && {
                    color: 'secondary.contrastText',
                    backgroundColor: 'secondary.main',
                    '&:hover': {
                      backgroundColor: 'secondary.dark',
                    },
                  }),
                }}
              >
                <SwapVertIcon />
              </IconButton>
            </Tooltip>
            {toggleButton}
          </Stack>
        </Stack>
      ) : (
        toggleButton
      )}
    </Box>
  );
};
